<template>
  <crud-base
    :url="url"
    :columns="columns"
    :onDelete="() => {}"
    :onUpdate="() => {}"
    :onStore="() => {}"
    :enableSearch="true"
    :checkAlerts="true"
    :formInputs="formInputs"
    primaryKey="id"
  />
</template>

<script>
import CrudBase from '../../../components/crud/CrudBase';
import { yesNoRepresentation } from '@/helpers/transformers';

export default {
  name: 'operacao-cliente',
  components: { CrudBase },
  data() {
    return {
      url: '/admin/condicoes/operacao-cliente',
      columns: [
        { label: 'ID', field: 'id', sortable: false },
        {
          label: 'Operação',
          field: 'operacao',
          sortable: false,
          representedAs: (row) =>
            row?.operacao
              ? `${row.operacao_id} - ${row.operacao.descricao}`
              : row.operacao_id,
        },
        {
          label: 'Cliente',
          field: 'cliente',
          sortable: false,
          representedAs: (row) =>
            row?.cliente
              ? `${row.cliente_id} - ${row.cliente.razaosocial}`
              : row.cliente_id,
        },
        {
          label: 'Ativo',
          field: 'ativo',
          sortable: false,
          representedAs: (row) => yesNoRepresentation(row.ativo),
        },
      ],
      formInputs: {
        id: {
          type: 'string',
          ui: {
            label: 'Identificador',
            columns: 4,
            widget: 'AutoIdWidget',
            widgetConfig: { campo1Key: 'operacao_id', campo2Key: 'cliente_id' },
          },
          rules: { required: { value: true, errMsg: 'Preencha o Identificador.' } },
        },
        operacao_id: {
          type: 'number',
          ui: {
            label: 'Operação',
            columns: 4,
            widget: 'SearchSelectWidget',
            widgetConfig: {
              searchUrl: '/admin/condicoes/operacoes',
              idField: 'id',
              labelField: 'descricao',
              preload: false,
            },
          },
          rules: { required: { value: true, errMsg: 'Campo obrigatório.' } },
        },
        cliente_id: {
          type: 'number',
          ui: {
            label: 'Cliente',
            columns: 4,
            widget: 'SearchSelectWidget',
            widgetConfig: {
              searchUrl: '/admin/clientes',
              idField: 'id',
              labelField: 'razSoc',
              labelFields: ['razSoc', 'fant'],
              preload: false,
            },
          },
          rules: { required: { value: true, errMsg: 'Campo obrigatório.' } },
        },
        ativo: {
          type: 'number',
          default: 1,
          ui: {
            label: 'Ativo',
            columns: 4,
            widget: 'select',
            widgetConfig: {
              placeholder: 'Selecione',
              enumSource: [{ label: 'Sim', value: 1 }, { label: 'Não', value: 0 }],
            },
          },
        },
      },
    };
  },
};
</script>
